import store from '../../store';
import {getActiveGifts} from '../../components/common';
import {showMenuAlert} from './menu.actions';

export const ADD_ITEM_TO_CART = '[CART APP] ADD ITEM';
export const REMOVE_ITEM_FROM_CART = '[CART APP] REMOVE ITEM';
export const RESET_CART = '[CART APP] RESET';
export const SET_CART = '[CART APP] SET';
export const SHOW_CART_ITEM = '[CART APP] SHOW ITEM';
export const HIDE_CART_ITEM = '[CART APP] HIDE ITEM';
export const UPDATE_CART_ITEM = '[CART APP] UPDATE ITEM';
export const CART_SET_SPECIAL_CATEGORY = '[CART APP] SET SPECIAL CATEGORY';
export const CART_RESET_SPECIAL_CATEGORY = '[CART APP] RESET SPECIAL CATEGORY';
export const ADD_GIFT_ITEM_TO_CART = '[CART APP] ADD GIFT ITEM';
export const REMOVE_GIFT_ITEM_FROM_CART = '[CART APP] REMOVE GIFT ITEM';
export const ADD_GIFT_ITEMS_TO_CART = '[CART APP] ADD GIFT ITEMS';
export const SELECT_GIFT_ITEM = '[CART APP] SELECT GIFT ITEM';
export const UPDATE_SELECTED_GIFT_ITEM = '[CART APP] UPDATE SELECTED GIFT ITEM';
export const REMOVE_SELECTED_GIFT_ITEM = '[CART APP] REMOVE SELECTED GIFT ITEM';

const getCurrentCartGiftItemsIdsAppendItem = (item, restaurant) => {
    const {cart} = store.getState();

    const gifts = getActiveGifts(restaurant.gifts, restaurant.menu_categories, [...cart.items, item], restaurant);
    
    return gifts.reduce((acc, category) => acc.concat(category.items.map(item => item.id)), []);
};

const getCurrentCartGiftItemsIdsUpdateItem = (item, restaurant) => {
    const {cart} = store.getState();
    
    const items = [...cart.items];
    items.splice(
        items.findIndex(it => it.id === item.id),
        1,
        item
    );
    
    const gifts = getActiveGifts(restaurant.gifts, restaurant.menu_categories, items, restaurant);
    
    return gifts.reduce((acc, category) => acc.concat(category.items.map(item => item.id)), []);
};

const getCurrentCartGiftItemsIdsWithoutItem = (itemIndex, restaurant) => {
    const {cart} = store.getState();

    const gifts = getActiveGifts(restaurant.gifts, restaurant.menu_categories, [...cart.items.filter((item, index) => index !== itemIndex)], restaurant);
    
    return gifts.reduce((acc, category) => acc.concat(category.items.map(item => item.id)), []);
};

// Anti-fraud UX: if a cart change leaves a gift currently in the cart no longer eligible (its id is
// no longer in the recomputed eligible giftItemsIds — the same predicate the reducer prunes on),
// notify the buyer. The reducer then removes that gift from the cart.
const notifyIfGiftDropped = (newGiftItemsIds) => {
    const {cart} = store.getState();
    const dropped = (cart.giftItems || []).some(gift => !newGiftItemsIds.includes(gift.id));
    if (dropped) {
        store.dispatch(showMenuAlert('You no longer qualify for the free gift, so it has been removed from your order.'));
    }
};

export function addItemToCart(item, restaurant) {
    return {
        type: ADD_ITEM_TO_CART,
        payload: item,
        giftItemsIds: getCurrentCartGiftItemsIdsAppendItem(item, restaurant),
    }
}

export function removeItemFromCart(itemIndex, restaurant) {
    const giftItemsIds = getCurrentCartGiftItemsIdsWithoutItem(itemIndex, restaurant);
    notifyIfGiftDropped(giftItemsIds);
    return {
        type: REMOVE_ITEM_FROM_CART,
        payload: itemIndex,
        giftItemsIds,
    }
}

export function resetCart() {
    return {
        type: RESET_CART
    }
}

export function setCart(items) {
    return {
        type: SET_CART,
        payload: items
    }
}

export function showCartItem(itemIndex) {
    return {
        type: SHOW_CART_ITEM,
        payload: itemIndex
    }
}

export function hideCartItem(item) {
    return {
        type: HIDE_CART_ITEM
    }
}

export function updateCartItem(item, restaurant) {
    const giftItemsIds = getCurrentCartGiftItemsIdsUpdateItem(item, restaurant);
    notifyIfGiftDropped(giftItemsIds);
    return {
        type: UPDATE_CART_ITEM,
        payload: item,
        giftItemsIds,
    }
}

export function cartSetSpecialCategory(item) {
    return {
        type: CART_SET_SPECIAL_CATEGORY,
        payload: item
    }
}

export function cartResetSpecialCategory() {
    return {
        type: CART_RESET_SPECIAL_CATEGORY,
    }
}

export function addGiftItemToCart(item) {
    return {
        type: ADD_GIFT_ITEM_TO_CART,
        payload: item
    }
}

export function removeGiftItemFromCart(itemIndex) {
    return {
        type: REMOVE_GIFT_ITEM_FROM_CART,
        payload: itemIndex
    }
}

export function addGiftItemsToCart(items) {
    return {
        type: ADD_GIFT_ITEMS_TO_CART,
        payload: items
    }
}

export function selectGiftItem(item, giftId) {
    return {
        type: SELECT_GIFT_ITEM,
        payload: {item, giftId}
    }
}

export function updateSelectedGiftItem(item, giftId) {
    return {
        type: UPDATE_SELECTED_GIFT_ITEM,
        payload: {item, giftId}
    }
}

export function removeSelectedGiftItem(item, giftId) {
    return {
        type: REMOVE_SELECTED_GIFT_ITEM,
        payload: {item, giftId}
    }
}
